import * as React from 'react';
import './playerSetup.css';
import Player from "../../fbobjects/Player";
import RunePage from '../RunePage';
import SkillOrderComponent from "../SkillOrderComponent/index";
import MasteryPage from "../MasteryPage/index";
import RiotDB from "../../fbobjects/RiotDB";
import CustomAutosuggest from "../CustomAutosuggest/index";
import GoogleSheetDB from "../../fbobjects/GoogleSheetDB";
import StatModalComponent from "../StatModalComponent/index";
import {ChampionRunes, SimRunes} from "../../fbobjects/calculation/CalculationObjects";
import {SimSkillOrder} from "../../fbobjects/calculation/SkillOrder";
import SimulationActions from "../../actions/SimulationActions";
import FBOM from "../../fbobjects/framework/FBOM";

interface PlayerSetupProps {
	player: Player;
	defaultChampion:string;
	playerNumber:number;
}


export default class PlayerSetup extends React.Component<PlayerSetupProps, any> {

	constructor(props: PlayerSetupProps) {
		super(props);

	}


	//TODO: find a way to check if a champion is currently selected to load the data

	gp():PlayerSetupProps{
		return this.props;
	}

	getChampionName():string{
		if (this.gp().player == undefined || this.gp().player.selectedChampion == undefined){
			return this.gp().defaultChampion;
		}
		return this.gp().player.selectedChampion;
	}

	getChampionRunes():ChampionRunes{
		let selectedRunes = this.gp().player.selectedRunes;
		if (selectedRunes == undefined){
			return GoogleSheetDB.getDefaultChampionRunesForChampion(this.getChampionName());
		}
		return selectedRunes;
	}

	renderChampionRunes(){
		let selectedRunes = this.getChampionRunes();
		if (selectedRunes == null){
			return <div className="no-page">This champion does not currently have runes to display</div>;
		}
		return <RunePage runePage={this.getChampionRunes()}/>
	}

	getSkillOrders():SimSkillOrder{
		let selectedSkillOrder = this.gp().player.selectedSkillOrder;
		if (selectedSkillOrder == undefined){
			return GoogleSheetDB.getDefaultSkillOrdersForChampion(this.getChampionName());
		}
		return selectedSkillOrder;
	}

	renderSkillOrder(){
		let selectedSkillOrder = this.getSkillOrders();
		if (selectedSkillOrder == null){
			return <div className="no-page">This champion does not currently have skill orders to display</div>;
		}
		return <SkillOrderComponent skillOrder={this.getSkillOrders()}/>
	}

	getPlayerOrder():any{
		let playerNumber = this.gp().playerNumber;
		if (playerNumber == 1 || playerNumber == undefined){
			return {flexDirection:"row-reverse"};
		}
		return {flexDirection:"row"};
	}


	render() {
		return (
			<div className="player-setup">

				<div className="container" style={this.getPlayerOrder()}>

					{/*<div className="splash-container">*/}
						{/*<img className="splash"*/}
							 {/*src={RiotDB.getChampionLoadingImgUrl(this.getChampionName())}*/}
						{/*/>*/}
					{/*</div>*/}

					<div className="header-stat-container">
						<div className="header">
							<CustomAutosuggest onChoose={(champName)=>SimulationActions.chooseChampion(this.gp().player, champName)}
											   suggestions={RiotDB.getChampionNames()}
											   type={"champion"}
											   defaultValue={this.getChampionName()}
											   onBlur={()=>{}}
							/>
						</div>
						<div className="stats-container">
							<div className="rune-page-container">
								<div className="stat-name">
									RUNES: {(this.getChampionRunes() != null) ? this.getChampionRunes().runes.name.toUpperCase() : ''}
								</div>
								{this.renderChampionRunes()}
							</div>

							<div className="skill-order-container">
								<div className="stat-name">
									SKILL ORDER
								</div>
								{this.renderSkillOrder()}
							</div>
							<div className="mastery-page-container">
								<div className="stat-name">
									MASTERIES
								</div>
								{/*<MasteryPage/>*/}
								<div className="no-page">Masteries are not available at this time</div>
							</div>
						</div>
					</div>
				</div>

				{/*TODO DELETE THIS AFTER DONE TESTING*/}
				<StatModalComponent data={GoogleSheetDB.getChampionRunesForChampion("Talon")}/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/PlayerSetup/index.tsx